import { LIST_STATES as STATE } from "./constants";

export const VERIFY_ACTIONS = {
    ASSISTED_MODE: 'assistedMode',
    ASSISTED_TRANSFER: 'assistedTransfer',
    BLIND_TRANSFER: 'blindTransfer',
    CHANGE_PASSWORD: 'changePassword',
    CHANGE_VOLUMEN: 'changeVolumen',
    CHAT_TO_ADMIN: 'chatToAdmin',
    DIGIT_DTMF: 'digitDTMF',
    DISPOSITIONS: 'dispositions',
    EXIT_DISPOSITIONS_MODE: 'exitDispositionsMode',
    HISTORY_CALLS: 'historyCalls',
    HISTORY_UNAVAILABLES: 'historyUnavailables',
    HOLD_CALL: 'holdCall',
    IVR: 'ivr',
    LOGIN: 'login',
    MUTE: 'mute',
    REPROGRAM: 'reprogram',
    SET_READY: 'setReady',
    STOP_START_RECORDING: 'stopStartRecording',
    TRANSFERS: 'transfers',
    UNAVAILABLES: 'unavailables',
    UPDATE_DATA: 'updateData',
}

export const stateMappings = {
    assistedMode: [STATE.ASSISTED],
    assistedTransfer: [STATE.DIALOG, STATE.OTHER],
    blindTransfer: [STATE.DIALOG, STATE.OTHER],
    changePassword: [STATE.READY, STATE.ASSISTED],
    changeVolumen: [STATE.FIRSTCALL, STATE.XFER, STATE.DIALOG, STATE.RINGING, STATE.ASSISTED, STATE.OTHER],
    chatToAdmin: [STATE.ASSISTED, STATE.DIALOG, STATE.NOTREADY, STATE.PROBLEM, STATE.OTHER, STATE.READY, STATE.WRAPUP],
    digitDTMF: [STATE.DIALOG, STATE.OTHER],
    dispositions: [STATE.DIALOG, STATE.WRAPUP, STATE.OTHER],
    exitDispositionsMode: [STATE.WRAPUP],
    historyCalls: [STATE.READY, STATE.NOTREADY, STATE.ASSISTED],
    historyUnavailables: [STATE.READY, STATE.PROBLEM, STATE.ASSISTED],
    holdCall: [STATE.DIALOG, STATE.OTHER],
    ivr: [STATE.DIALOG, STATE.OTHER],
    login: [STATE.LOGOUT],
    mute: [STATE.DIALOG, STATE.OTHER],
    reprogram: [STATE.DIALOG, STATE.WRAPUP, STATE.OTHER],
    setReady: [STATE.READY, STATE.WRAPUP, STATE.NOTREADY],
    stopStartRecording: [STATE.DIALOG, STATE.OTHER],
    transfers: [STATE.LOGIN],
    unavailables: [STATE.READY, STATE.XFER, STATE.DIALOG, STATE.RINGING, STATE.NOTREADY, STATE.WRAPUP, STATE.ASSISTED],
    updateData: [STATE.DIALOG, STATE.OTHER],
};

export function verifyState(action, state){
    if(state === 'All'){
        return true;
    }
    if(state === 'Problem'){
        return false;
    }
    const states = stateMappings[action];
    return states ? states.includes(state) : false;
}